import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import {
  FilterNone as UIElementsIcon,
  HowToReg,
  Dashboard,
  AccountBalance,
  MonetizationOn,
  ApartmentRounded,
  Input,
  QuestionAnswer as SupportIcon,
  LibraryBooks as LibraryIcon,
  HelpOutline as FAQIcon,
  ArrowBack as ArrowBackIcon,
} from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";
import auth from "../../auth/auth-helper";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";

var structure = [{
  id: 0,
  label: "Dashboard",
  link: "/app/dashboard",
  icon: <Dashboard />,
},
{
  id: 15,
  label: "Transactions",
  link: "/app/transactions",
  icon: <UIElementsIcon />,
  children: [
    { label: "Online Transactions", link: "/app/transaction/online" },
    { label: "ATM Transactions", link: "/app/transaction/atm" },
    { label: "Bank Transactions", link: "/app/transaction/bank" },
    { label: "Loan Transactions", link: "/app/transaction/loan" },
  ],
},
{
  id: 16,
  label: "Bank Transction",
  link: "/app/transaction/create-bank-transaction",
  icon: <Dashboard />,
},
{
  id: 55,
  label: "Loan Instllment Transction",
  link: "/app/transaction/installment-transaction",
  icon: <Dashboard />,
},
{
  id: 17,
  label: "Accounts",
  link: "/app/account",
  icon: <AccountBalance />,
},
{
  id: 18,
  label: "Loans",
  link: "/app/loan",
  icon: <UIElementsIcon />,
  children: [
    { label: "All Loans", link: "/app/loan/all-loans" },
    { label: "Online Loans", link: "/app/loan/online-loans" },
    { label: "Direct Loans", link: "/app/loan/direct-loans" },
    { label: "Rejected Loans", link: "/app/loan/rejected-loans" },
  ],
},

{ id: 5, type: "divider" },
{ id: 6, type: "title", label: "HELP" },
{ id: 7, label: "Library", link: "", icon: <LibraryIcon /> },
{ id: 8, label: "Support", link: "", icon: <SupportIcon /> },
{ id: 9, label: "FAQ", link: "", icon: <FAQIcon /> },
{ id: 10, type: "divider" },];

function Sidebar({ location }) {
  if (auth.getuserType() == "clerk") {
    structure = [
      {
        id: 0,
        label: "Dashboard",
        link: "/app/dashboard",
        icon: <Dashboard />,
      },
      {
        id: 15,
        label: "Transactions",
        link: "/app/transactions",
        icon: <UIElementsIcon />,
        children: [
          { label: "Online Transactions", link: "/app/transaction/online" },
          { label: "ATM Transactions", link: "/app/transaction/atm" },
          { label: "Bank Transactions", link: "/app/transaction/bank" },
          { label: "Loan Transactions", link: "/app/transaction/loan" },
        ],
      },
      {
        id: 16,
        label: "Bank Transction",
        link: "/app/transaction/create-bank-transaction",
        icon: <Dashboard />,
      },
      {
        id: 16,
        label: "Loan Instllment Transction",
        link: "/app/transaction/installment-transaction",
        icon: <Dashboard />,
      },
      {
        id: 56,
        label: "Manual Loan",
        link: "/app/loan/request-manual-loans",
        icon: <Dashboard />,
      },
      {
        id: 17,
        label: "Accounts",
        link: "/app/account",
        icon: <AccountBalance />,
      },
      {
        id: 18,
        label: "Loans",
        link: "/app/loan",
        icon: <UIElementsIcon />,
        children: [
          { label: "All Loans", link: "/app/loan/all-loans" },
          { label: "Online Loans", link: "/app/loan/online-loans" },
          { label: "Direct Loans", link: "/app/loan/direct-loans" },
          { label: "Rejected Loans", link: "/app/loan/rejected-loans" },
        ],
      },

      { id: 5, type: "divider" },
      { id: 6, type: "title", label: "HELP" },
      { id: 7, label: "Library", link: "", icon: <LibraryIcon /> },
      { id: 8, label: "Support", link: "", icon: <SupportIcon /> },
      { id: 9, label: "FAQ", link: "", icon: <FAQIcon /> },
      { id: 10, type: "divider" },
    ];
  } else if (auth.getuserType() == "manager") {
    structure = [
      {
        id: 0,
        label: "Dashboard",
        link: "/app/dashboard",
        icon: <Dashboard />,
      },
      {
        id: 1,
        label: "Branch",
        link: "/app/branch",
        icon: <ApartmentRounded />,
      },
      {
        id: 0,
        label: "Clerks",
        link: "/app/clerk",
        icon: <HowToReg />,
      },
      {
        id: 15,
        label: "Transactions",
        link: "/app/transactions",
        icon: <MonetizationOn />,
        children: [
          { label: "Online Transactions", link: "/app/transaction/online" },
          { label: "ATM Transactions", link: "/app/transaction/atm" },
          { label: "Bank Transactions", link: "/app/transaction/bank" },
          { label: "Loan Transactions", link: "/app/transaction/loan" },
        ],
      },
      {
        id: 16,
        label: "LoanRequests",
        link: "/app/loanRequest",
        icon: <Input />,
      },
      {
        id: 17,
        label: "Accounts",
        link: "/app/account",
        icon: <AccountBalance />,
      },
      {
        id: 18,
        label: "Loans",
        link: "/app/loan",
        icon: <UIElementsIcon />,
        children: [
          { label: "All Loans", link: "/app/loan/all-loans" },
          { label: "Online Loans", link: "/app/loan/online-loans" },
          { label: "Direct Loans", link: "/app/loan/direct-loans" },
          { label: "Rejected Loans", link: "/app/loan/rejected-loans" },
        ],
      },
      { id: 5, type: "divider" },
      { id: 6, type: "title", label: "HELP" },
      { id: 7, label: "Library", link: "", icon: <LibraryIcon /> },
      { id: 8, label: "Support", link: "", icon: <SupportIcon /> },
      { id: 9, label: "FAQ", link: "", icon: <FAQIcon /> },
      { id: 10, type: "divider" },
    ];
  } else if (auth.getuserType() == "customer") {
    structure = [
      {
        id: 0,
        label: "Dashboard",
        link: "/app/dashboard",
        icon: <Dashboard />,
      },
      {
        id: 17,
        label: "Account",
        link: "/app/account",
        icon: <AccountBalance />,
      },
      {
        id: 15,
        label: "Online Transction",
        link: "/app/transaction/create-transaction",
        icon: <Dashboard />,
      },
      {
        id: 15,
        label: "Atm Transction",
        link: "/app/transaction/create-atm-transaction",
        icon: <Dashboard />,
      },
      {
        id: 56,
        label: "Online Loan",
        link: "/app/loan/request-online-loans",
        icon: <Dashboard />,
      },
      { id: 5, type: "divider" },
      { id: 6, type: "title", label: "HELP" },
      { id: 7, label: "Library", link: "", icon: <LibraryIcon /> },
      { id: 8, label: "Support", link: "", icon: <SupportIcon /> },
      { id: 9, label: "FAQ", link: "", icon: <FAQIcon /> },
      { id: 10, type: "divider" },
    ];
  }
  var classes = useStyles();
  var theme = useTheme();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);

  useEffect(function () {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList}>
        {structure.map((link) => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        ))}
      </List>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
